module.exports = __webpack_public_path__ + "img/14.f28acf5b.png";